﻿
export class DropDown {

  private element: HTMLElement;
  
  public get flyout(): HTMLElement {
    let flyoutId = this.element.getAttribute('data-dropdown-flyout-id');
    return document.querySelector('dropdown-flyout'.asDataSelector(flyoutId))
  };

  public constructor(element: HTMLElement) {
    if (!element)
      throw new Error("You must provide an element to DropDown");

    this.element = element;
    $(element).dropDown();
  }
}

export interface IOption {
  text: string;
  value: string;
}

export default DropDown;